import { render, staticRenderFns } from "./GeneratorModuleFormGroup.vue?vue&type=template&id=c4971cd8&"
import script from "./GeneratorModuleFormGroup.vue?vue&type=script&lang=ts&"
export * from "./GeneratorModuleFormGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports